module.exports = __webpack_public_path__ + "img/behance board.fa401366.png";